import { type WorkflowKind } from '../models';
import ItemFilter from './ItemFilter';

class FeatureTypeFilter extends ItemFilter<string> {
  matches(record: { workflowKind: WorkflowKind }) {
    // Note that this is matching against the name directly rather than id
    return (
      super.matches(record) ||
      ('workflowKind' in record &&
        record.workflowKind &&
        this.itemIsSelected(record.workflowKind.name))
    );
  }
}

export default FeatureTypeFilter;
